import React, { Component } from "react";
import { Table, Button, Col, Row, Tooltip } from "antd";
import axios from "axios";
import PrintModal from '../components/PrintModal';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";
import Colors from "../utils/Colors";

const { Column } = Table;

class CompraPrintModal extends Component {
    state = {
        registro: [],
        com_idf: 0,
        com_qtde_prod: 0,
        com_vlr_total: 0,
        listaProdutos: [],
        listaParcelas: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        // console.log('CompraPrintModal - componentDidUpdate - this.props: ', this.props);
        // console.log('CompraPrintModal - componentDidUpdate - propsAnte: ', propsAnte);

        if ((this.props.visivel !== propsAnte.visivel) && (this.props.com_idf)) {
            // console.log('CompraPrintModal - componentDidUpdate - 2222222');
            this.setState({
                com_idf: this.props.com_idf,
                registro: [],
                visualizar: true,
            });
            this.getListaRegistros();
        }
    }

    getListaRegistros = () => {
        this.setState({ carregando: true, listaRegistros: [] });
        const { com_idf } = this.props;

        axios
            .get(`/compras/show/${com_idf}`)
            .then(response => {
                const { data } = response;

                // console.log('CompraPrintModal - getListaRegistros: ', data);

                let com_qtde_prod = 0;
                let com_vlr_total = 0;
                for (var x in data.listaProdutos) {
                    com_qtde_prod = com_qtde_prod + parseFloat(data.listaProdutos[x].mi_qtde);
                    com_vlr_total = com_vlr_total + parseFloat(data.listaProdutos[x].mi_vlr_total);
                };

                this.setState({
                    registro: data.dados,
                    listaProdutos: data.listaProdutos,
                    listaParcelas: data.listaParcelas,
                    com_qtde_prod,
                    com_vlr_total,
                    carregando: false,
                });
            })
            .catch(erro => {
                console.warn(erro);
                this.setState({
                    carregando: false,
                });
            });
    };

    onCancelar = () => {
        this.setState({
            com_idf: 0,
            registro: [],
            visualizar: false,
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true,
        })
    }

    renderValor = (com_vlr_total, registro) => {
        return (
            <span> {numeral(parseFloat(com_vlr_total)).format('0,000.00')} </span>
        );
    };

    renderData = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY HH:mm')}
                </span>
            )
        } else {
            <span>-</span>
        }
    }

    renderDataParc = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY')}
                </span>
            )
        } else {
            <span>-</span>
        }
    }

    render() {
        const { onCancelarPrintClick, visivel } = this.props;
        const { carregando, visualizar, listaProdutos, listaParcelas } = this.state;
        const { com_numero, com_dt_compra, com_pessoa, pes_nome, usu_nome,
            cp_descricao, com_obs, pes_fone1, pes_fone2, pes_fone3,
            pes_endereco, pes_numero, pes_bairro, pes_cep, cmun_descricao, cuf_sigla } = this.state.registro;

        // console.log('CompraPrintModal: ', this.state);

        return (
            <span style={{}}>
                {/* <Tooltip title="Imprimir">
                    <Button style={{ height: 25, width: 35, padding: 0 }} onClick={this.onVisualizar} icon="printer" />
                </Tooltip> */}
                <PrintModal
                    visible={visivel}
                    onCancel={onCancelarPrintClick}
                // onCancel={this.onCancelar}
                >
                    {this.state.registro ? (
                        <div>
                            <Row className="titulo">
                                Compra
                            </Row>

                            <div style={{ marginTop: 20, height: 2, backgroundColor: Colors.background }} />

                            <Row style={{ marginLeft: 20, marginTop: 10 }}>
                                <Col xs={6} style={{ marginTop: 5 }} >
                                    <span style={{ fontWeight: 'bold' }}>Número: </span>
                                    <span> {com_numero} </span>
                                </Col>
                                <Col xs={16} style={{ marginTop: 5 }} >
                                    <span style={{ fontWeight: 'bold' }}>Data: </span>
                                    <span> {this.renderData(com_dt_compra)} </span>
                                </Col>
                                <Col xs={24} style={{ marginTop: 5 }} >
                                    <span style={{ fontWeight: 'bold', fontSize: 20 }}>Cliente: </span>
                                    <span> {com_pessoa + ' - ' + pes_nome} </span>
                                </Col>
                                {com_obs ? (
                                    <Col xs={24} style={{ marginTop: 5 }} >
                                        <span style={{ fontWeight: 'bold' }}>OBS: </span>
                                        <span> {com_obs} </span>
                                    </Col>
                                ) : null}
                            </Row>

                            <Row style={{ marginTop: 10 }}>
                                <Col xs={5} style={{ marginTop: 5 }} >
                                    <span></span>
                                </Col>
                                <Col xs={9} style={{ marginTop: 5, textAlign: "end" }} >
                                    <span style={{ fontSize: 16, fontWeight: 'bold' }}>Qtde Produtos: </span>
                                    <span style={{ fontSize: 17 }}> {this.state.com_qtde_prod} </span>
                                </Col>
                                <Col xs={10} style={{ marginTop: 5, textAlign: "end" }} >
                                    <span style={{ fontSize: 16, fontWeight: 'bold' }}>Valor da Compra: </span>
                                    <span style={{ fontSize: 17 }}> R$ {this.renderValor(this.state.com_vlr_total)} </span>
                                </Col>
                            </Row>

                            <Row style={{ marginBottom: 20 }}>
                                <div style={{ color: Colors.textDisabledDark, fontSize: 16, fontWeight: "bold", paddingLeft: 20, paddingTop: 3, marginTop: 10, marginBottom: 10, height: 30, backgroundColor: Colors.background }}>
                                    LISTA DE PRODUTOS
                            </div>

                                <Row>
                                    <Table
                                        pagination={false}
                                        dataSource={listaProdutos}
                                        // className="tabela"
                                        rowKey={(listaRegistros => listaRegistros.mi_idf)}
                                        loading={{
                                            spinning: carregando,
                                            tip: 'Carregando. Aguarde...',
                                            size: "large"
                                        }}
                                    >
                                        <Column
                                            key="prod_codigo"
                                            dataIndex="prod_codigo"
                                            title="Item"
                                            width={80}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="prod_descricao"
                                            dataIndex="prod_descricao"
                                            title="Descrição do Item"
                                            width={300}
                                            align="left"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="mi_qtde"
                                            dataIndex="mi_qtde"
                                            title="Qtde"
                                            render={this.renderValor}
                                            width={90}
                                            align="right"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="mi_vlr_unit"
                                            dataIndex="mi_vlr_unit"
                                            title="Vlr Unitário"
                                            render={this.renderValor}
                                            width={90}
                                            align="right"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="mi_vlr_desc"
                                            dataIndex="mi_vlr_desc"
                                            title="Desconto"
                                            render={this.renderValor}
                                            width={90}
                                            align="right"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="mi_vlr_total"
                                            dataIndex="mi_vlr_total"
                                            title="Valor Total"
                                            render={this.renderValor}
                                            width={90}
                                            align="right"
                                            className="listaCadastro"
                                        />
                                    </Table>
                                </Row>
                            </Row>

                            {listaParcelas && listaParcelas.length > 0 ? (
                                <Row style={{ marginTop: 10, marginBottom: 20 }}>
                                    <div style={{ color: Colors.textDisabledDark, fontSize: 16, fontWeight: "bold", paddingLeft: 20, paddingTop: 3, marginTop: 10, marginBottom: 10, height: 30, backgroundColor: Colors.background }}>
                                        FORMA DE PAGAMENTO - {cp_descricao}
                                    </div>
                                    <Row>
                                        <Table
                                            dataSource={listaParcelas}
                                            pagination={false}
                                            rowKey={(listaParcelas => listaParcelas.tparc_parcela)}
                                            // loading={{
                                            //     spinning: carregando,
                                            //     tip: 'Carregando. Aguarde...',
                                            //     size: "large"
                                            // }}
                                        >
                                            <Column
                                                key="tparc_parcela"
                                                dataIndex="tparc_parcela"
                                                title="Parcela"
                                                width={60}
                                                align="center"
                                                className="listaCadastro"
                                            />
                                            <Column
                                                key="tparc_data_parcela"
                                                dataIndex="tparc_data_parcela"
                                                title="Data Venc"
                                                width={80}
                                                align="center"
                                                className="listaCadastro"
                                                render={this.renderDataParc}
                                            />
                                            <Column
                                                key="tparc_valor"
                                                dataIndex="tparc_valor"
                                                title="Valor Parc"
                                                render={this.renderValor}
                                                width={80}
                                                align="right"
                                                className="listaCadastro"
                                            />
                                            <Column
                                                key="situacao_parcela"
                                                dataIndex="situacao_parcela"
                                                title="Situação"
                                                width={80}
                                                align="center"
                                                className="listaCadastro"
                                            />
                                            <Column
                                                key="td_descricao"
                                                dataIndex="td_descricao"
                                                title="Tipo Documento"
                                                width={300}
                                                align="left"
                                                className="listaCadastro"
                                            />
                                        </Table>
                                    </Row>
                                </Row>
                            ) : null}


                        </div>
                    ) : null}

                </PrintModal>
            </span>
        );
    }
}

export default CompraPrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/CompraPrintModal.js